import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'hasParty',
  pure: true
})
@Injectable({ providedIn: 'root' }) // Allows injection in components
export class HasPartyPipe implements PipeTransform {
  //Checks whether the given party exists in the dummyParties list.
  //If the party is found in dummyParties, it returns false, meaning the party should not be shown in the web app.
  //If the party is not found in dummyParties, it returns true, allowing it to be displayed.
  //Any party listed in `dummyParties` should not be displayed in the web app.
  transform(dummyParties: string[], party: string): boolean {
    if (!party) return true; // If party is null, undefined, or empty, return true
    if (!dummyParties || dummyParties.length === 0) return true; // If dummyParties is empty or null, return true
  
    let trimmedParty = party.trim().toLocaleLowerCase();
    return !dummyParties.some(p => p.trim().toLocaleLowerCase() === trimmedParty);
  }
}
